/**
 * @ngInject
 */
function Directive() {
  return {
    scope: {},
    bindToController: {
      familyName: '=',
      imageItem: '=',
      displayView: '@',
      itemSize: '@',
      isVisibleByDefault: '='
    },
    controller: require('./controller.js'),
    controllerAs: 'fontImageCardCtrl',
    restrict: 'E',
    replace: true,
    transclude: true,
    templateUrl: '/angular_templates/directives/adobe_fonts_family_image_card.html'
  };
}

module.exports = Directive;
